import { useState } from "react";

export interface UIHoverProps {
    renderControl: (isHovered: boolean) => JSX.Element;
}

export function UIHover(props: UIHoverProps) {
    const [hovered, setHovered] = useState<boolean>(false);

    return (
        <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            {props.renderControl(hovered)}
        </div>
    );
}
